<script>
  import { onMount } from 'svelte';
  import CategoryDropdown from './CategoryDropdown.svelte';
  import CategoryMenu from './CategoryMenu.svelte';
  import LoadingProducts from './LoadingProducts.svelte';
  import ProductGrid from './ProductGrid.svelte';
  import SearchInput from './SearchInput.svelte';
  import { getCategories, getProducts, createOrder } from '../actions';
  import { media, categoryStore, productStore, productDownloadStore } from '../stores';

	onMount(async () => {
    await Promise.all([getCategories(), getProducts($productStore.filters)]);
  });

  async function handleSearch(e) {
    if (e.detail.query && e.detail.query.length > 0) {
      await getProducts({ page: 1, category: $productStore.filters.category, search: e.detail.query });
    } else {
      await getProducts({ page: 1, category: $productStore.filters.category, search: null });
    }
  }

  async function handleCategoryClear() {
    await getProducts({ page: 1, category: null, search: $productStore.filters.search });
  }

  async function handleCategoryChange(e) {
    await getProducts({ page: 1, category: e.detail.categoryId, search: $productStore.filters.search });
  }

  async function handlePageChange(e) {
    await getProducts({ page: e.detail.page, category: $productStore.filters.category, search: $productStore.filters.search });
  }

  async function handleProductDownload(e) {
    await createOrder(e.detail.productId, e.detail.downloadId);
  }
</script>

<main class="ui grid">
  <div class="row">
    <div class="column">
      <div class="ui fluid vertical menu">
        {#if $media.desktopView}
          <div class="item">
            <SearchInput on:search={handleSearch} />
          </div>
        {:else}
          <div class="item">
            <SearchInput on:search={handleSearch} mobile={true} />
          </div>
          <div class="item">
            <CategoryDropdown
              categories={$categoryStore.categories} 
              on:change={handleCategoryChange} 
              on:clear={handleCategoryClear} 
            />
          </div>
        {/if}
      </div>
    </div>
  </div><!--/.row-->
  <div class="row">
    {#if $media.desktopView}
      <div class="three wide computer only column">
        <CategoryMenu 
          categories={$categoryStore.categories} 
          on:change={handleCategoryChange} 
          on:clear={handleCategoryClear} 
        />
      </div>
    {/if}
    <div class="sixteen wide mobile thirteen wide computer column">
      {#if $productStore.loading}
        <LoadingProducts />
      {:else}
        <ProductGrid 
          products={$productStore.products}
          pages={$productStore.pages}
          currentPage={$productStore.filters.page}
          on:pageChange={handlePageChange}
          productDownload={$productDownloadStore}
          on:clickDownload={handleProductDownload} 
        />
      {/if}
    </div>
  </div><!--/.row-->
</main>

<style>
  :global(.ui.menu) {
    font-size: 14px;
  }
</style>